import React from 'react';
import ExpireTimerPicker from "../../ExpireTimerPicker";
import {updateExpirationTime} from "../../../../../../../services/company/api";

const ExpirationSettings = ({ expiration, client }) => {
    const updateExpirationTimeHandler = (expirationTime, expirationEnabled) => {
        updateExpirationTime(client.id, expirationTime, expirationEnabled);
    };
    return (
        <React.Fragment>
            {expiration && (
                <ExpireTimerPicker expiration={expiration} updateExpirationTime={updateExpirationTimeHandler} />
            )}
        </React.Fragment>
    );
};

export default ExpirationSettings;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/new/functions/ExpirationSettings.jsx